import { cexExchangesTimeframes } from 'types/charts';
import { ECexName } from 'web3';

const RESOLUTION_TO_TIMEFRAME: Record<string, string> = {
  '1S': '1s',
  '10S': '10s',
  '30S': '30s',
  '1': '1m',
  '5': '5m',
  '15': '15m',
  '30': '15m',
  '60': '1h',
  '120': '1h',
  '240': '4h',
  '360': '4h',
  '720': '4h',
  '1D': '1d',
  D: '1d',
  '1W': '1w',
  W: '1w',
};

const SECONDS_INTERVALS: Partial<Record<ECexName, Record<number, string>>> = {
  [ECexName.binance]: {
    1: '1s',
  },
  [ECexName.gate]: {
    // Note: Gate.io only supports 1s and 10s for sub-minute intervals
    // 30s is NOT supported - it will fall back to cexExchangesTimeframes (1m)
    10: '10s',
  },
};

export const mapResolutionToExchangeInterval = (exchange: ECexName, resolution: string): string => {
  const normalized = resolution.toUpperCase();
  const timeframeKey = RESOLUTION_TO_TIMEFRAME[normalized] ?? '1m';

  // Check for explicit seconds-level interval mappings first
  if (timeframeKey.endsWith('s')) {
    const seconds = Number(timeframeKey.slice(0, -1));
    const secondsMap = SECONDS_INTERVALS[exchange];
    const interval = secondsMap?.[seconds];

    if (interval) {
      return interval;
    }

    // Fall through to cexExchangesTimeframes for seconds intervals not explicitly mapped
    // This ensures unsupported intervals (like Gate 30s) get proper fallback (e.g., to 1m)
  }

  // Use cexExchangesTimeframes for the canonical exchange-specific interval
  const exchangeMap = (cexExchangesTimeframes as Record<string, Record<ECexName, any>>)[
    timeframeKey
  ];
  const interval = exchangeMap?.[exchange];

  if (!interval) {
    return '1m';
  }

  return typeof interval === 'string' ? interval : String(interval);
};
